export default __webpack_public_path__ + "static/media/Applied_CouponIcon.564048bc.svg";